import React, { useState, useLayoutEffect, useRef } from 'react'
import { CFormInput, CTable, CTableDataCell, CTableHeaderCell, CTableBody, CTableRow, CTableHead, CModal, CModalHeader, CModalBody, CModalFooter, CButton, CTooltip, CCard, CCardImage, CCardBody, CCardTitle, CCardText, CCardFooter } from '@coreui/react'
import { TableVirtuoso } from 'react-virtuoso'
import axios from 'axios'
import ReactLoading from 'react-loading'
import exportFromJSON from "export-from-json";
import Swal from "sweetalert2";
import InsertRestaurante from './InsertRestaurante'
import EditRestaurante from './EditRestaurante'
import QR from './QR'
import './Restaurantes.css'

function Restaurantes() {
    const qrRef = useRef(null)
    let [loading, setLoading] = useState(true)
    let [restaurantes, setRestaurantes] = useState([])
    let [restaurantesOG, setRestaurantesOG] = useState([])
    let [visible, setVisible] = useState(false)
    let [visible2, setVisible2] = useState(false)
    let [visible3, setVisible3] = useState(false)
    let [infoEdit, setInfoEdit] = useState({})
    let [infoEditOG, setInfoEditOG] = useState({})
    let [idparaQR, setIdparaQR] = useState("")
    let [modalTitle, setModalTitle] = useState("")

    const excludeColumns = ["_id", "is_active", "createdAt", "updatedAt"]; // excluye datos del arreglo donde se buscara

    const downloadQR = () => {
        if (!qrRef.current) return

        const canvas = qrRef.current.querySelector('canvas')
        if (!canvas) return

        const link = document.createElement('a')
        link.download = `Qr_${modalTitle.replace(/[^a-zA-Z0-9]/g, '')}.jpg`
        link.href = canvas.toDataURL('image/jpeg', 1.0)
        link.click()
    }

    function getRestaurantes() {
        axios.get(`${process.env.REACT_APP_BackURL}/getAllRestaurants?all=true`)
            .then((response) => {
                const data = [...response.data.data].reverse();
                setRestaurantes(data);
                setRestaurantesOG(data);
                setLoading(false)
            })
            .catch((err) => { console.log(err) })
    }

    // handle change event of search input
    function handleChange(value) {
        filterData(value);
    };

    // filter records by search text
    function filterData(value) {
        const searchTerms = value.toLowerCase().trim().split(/\s+/); // Divide por espacios
        if (searchTerms.length === 1 && searchTerms[0] === "") {
            setRestaurantes(restaurantesOG);
            return;
        }

        const filteredData = restaurantesOG.filter((item) => {
            // Verifica cada término de búsqueda en los campos no excluidos
            return searchTerms.every(term => {
                return Object.keys(item).some((key) => {
                    if (excludeColumns.includes(key)) return false;
                    return item[key].toString().toLowerCase().includes(term);
                });
            });
        });

        setRestaurantes(filteredData);
    };

    async function subirImagenACloudinary(archivo, nombreImagen, folder, tags) {

        return new Promise(async (resolve, reject) => {
            let img = new Image();
            img.src = URL.createObjectURL(archivo);
            let formData = new FormData();
            formData.append("file", archivo);
            formData.append("upload_preset", "upload_bebbo_restaurante");
            formData.append("user", tags);
            formData.append("folder", folder);
            formData.append("public_id", nombreImagen);
            try {
                let res = await axios.post(`${process.env.REACT_APP_BackURL}/upMedia`, formData,
                    // {
                    //     onUploadProgress: (e) => {
                    //         let percent = Math.round((e.loaded * 100) / e.total);
                    //         console.log(percent);
                    //     }
                    // }
                );
                resolve(res.data.secure_url);
            } catch (err) { reject(err); }
        });
    };

    async function repetirSucursal(itemOriginal) {

        const item = { ...itemOriginal };
        const originalId = item._id;
        delete item._id;

        // 👇 1) Pedir el NUEVO correo ANTES del POST
        let nuevoEmail;
        while (true) {
            const { value, isConfirmed } = await Swal.fire({
                icon: 'question',
                title: 'Nuevo correo para la sucursal',
                html: `
                <p style="font-size:13px;text-align:left;">
                    El correo original <b>${itemOriginal.email ?? '(sin correo)'}</b> ya está en uso.<br/>
                    Ingresa un correo distinto para esta nueva sucursal:
                </p>
            `,
                input: 'email',
                inputValue: '',
                showCancelButton: true,
                confirmButtonText: 'Crear sucursal',
                cancelButtonText: 'Cancelar',
                inputValidator: (v) => {
                    if (!v) return 'Debes ingresar un correo';
                    if (!/^\S+@\S+\.\S+$/.test(v)) return 'Correo inválido';
                    if (v === itemOriginal.email) return 'Debe ser distinto al original';
                }
            });

            if (!isConfirmed) return; // usuario canceló → salir sin crear nada
            nuevoEmail = value;
            break;
        }

        item.email = nuevoEmail;

        // 👇 2) Obtener logo del original (si existe)
        let file = null;
        try {
            const url = `https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/logo/logo${originalId}.jpg`;
            const res = await fetch(url);
            if (res.ok) {
                const blob = await res.blob();
                file = new File([blob], `logo${originalId}.jpg`, { type: "image/jpeg" });
            } else {
                console.warn('Logo original no encontrado, status:', res.status);
            }
        } catch (e) {
            console.warn('No se pudo obtener el logo original:', e);
        }

        // 👇 3) POST único con el nuevo correo

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BackURL}/insertRestaurant`,
                item
            );
            console.log('respuesta POST:', response);

            const nuevoId = response.data?.data?._id;

            if (file && nuevoId) {
                try {
                    await subirImagenACloudinary(file, `logo${nuevoId}`, `bebbo/logo`, nuevoId);
                } catch (e) {
                    console.warn('Restaurante creado pero falló la subida del logo:', e);
                }
            }

            Swal.fire({
                icon: 'success',
                title: 'Restaurante creado con éxito',
                allowEscapeKey: true
            }).then((result) => { if (result.isConfirmed) { getRestaurantes() } });

        } catch (err) {
            const status = err.response?.status;

            // 👇 4) Si aún así da 409 (el email nuevo también existe), volver a pedir
            if (status === 409) {
                await Swal.fire({
                    icon: 'warning',
                    title: 'Ese correo también está en uso',
                    text: err.response?.data?.message || 'El correo ingresado ya existe. Intenta con otro.',
                });
                // reintenta todo el flujo (vuelve a pedir email)
                return repetirSucursal(itemOriginal);
            }

            // Otros errores → Swal con detalle
            Swal.fire({
                icon: 'error',
                title: `${err.message} Error al crear el restaurante`,
                width: 600
            });
        }
    }

    function eliminarSucursal(item) {
        Swal.fire({
            icon: 'warning',
            title: '¿Estas seguro?',
            text: "No podras revertir esta accion",
            showCancelButton: true,
            confirmButtonColor: '#46eb34',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, borrar',
        })
            .then((result) => {
                if (result.isConfirmed) {

                    axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${item._id}`, { isActive: false })
                        .then((response) => {
                            Swal.fire({
                                icon: 'success',
                                title: 'Restaurante eliminado con éxito',
                                timerProgressBar: true,
                                allowEscapeKey: true
                            })
                                .then((result) => { if (result.isConfirmed) { getRestaurantes() } })
                        })
                        .catch((err) => { console.log(err) })
                }
            })
    }

    function commingSoon(item) {
        let boolean = !item.commingSoon
        axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${item._id}`, { commingSoon: boolean })
            .then((response) => {
                Swal.fire({
                    icon: 'success',
                    title: `El restaurante ${boolean ? "aparecera en la app como próximamente" : "aparecera en la app como abierto"}`,
                    timerProgressBar: true,
                    allowEscapeKey: true
                })
                    .then((result) => { if (result.isConfirmed) { getRestaurantes() } })
            })
            .catch((err) => { console.log(err) })
    }

    function published(item) {
        let boolean = !item.published
        axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${item._id}`, { published: boolean })
            .then((response) => {
                Swal.fire({
                    icon: 'success',
                    title: `El restaurante ${boolean ? "se publicara en la app" : "no se publicara en la app"}`,
                    timerProgressBar: true,
                    allowEscapeKey: true
                })
                    .then((result) => { if (result.isConfirmed) { getRestaurantes() } })
            })
            .catch((err) => { console.log(err) })
    }

    function featured(item) {
        let boolean = !item.featured
        axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${item._id}`, { featured: boolean })
            .then((response) => {
                Swal.fire({
                    icon: 'success',
                    title: `El restaurante ${boolean ? "se marco como destacado" : "se desmarco como destacado"}`,
                    timerProgressBar: true,
                    allowEscapeKey: true
                })
                    .then((result) => { if (result.isConfirmed) { getRestaurantes() } })
            })
            .catch((err) => { console.log(err) })
    }

    function exportarExcel() {

        let datos = []

        let dias = {
            0: 'Domingo',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miercoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sabado'
        }

        for (let i in restaurantes) {
            if (restaurantes[i].isActive) {
                datos.push({
                    'Publicado': restaurantes[i].published ? 'Si' : 'No',
                    'Proximamente': restaurantes[i].commingSoon ? 'Si' : 'No',
                    'Destacado': restaurantes[i].featured ? 'Si' : 'No',
                    'Nombre': restaurantes[i].name,
                    'Dirección': restaurantes[i].address,
                    'Tel': restaurantes[i].tel,
                    'WhatsApp': restaurantes[i].whatsapp,
                    'Correo': restaurantes[i].email,
                    'Tipo': restaurantes[i].type,
                    'Horarios': restaurantes[i].times ? restaurantes[i].times.join(' | ') : '',
                    'Horario Promo': restaurantes[i].timesPromo ? restaurantes[i].timesPromo.map(h => `${dias[h.dia]} ${h.inicio}-${h.fin}`).join(' | ') : '',
                    'Redes': restaurantes[i].redes
                        ? restaurantes[i].redes
                            .map(r => {
                                const red = Object.keys(r)[0];
                                const url = Object.values(r)[0].split('?')[0]; // quita los parámetros
                                return `${red.charAt(0).toUpperCase() + red.slice(1)}: ${url}`;
                            })
                            .join(' | ')
                        : '',
                    'Banners': restaurantes[i].banners ? restaurantes[i].banners.join(' | ') : '',
                    'Condiciones': restaurantes[i].condiciones,
                    'Google Maps': restaurantes[i].googleMapsURL,
                    'Lat Long': restaurantes[i].latLong,
                    'Menu PDF': restaurantes[i].menuPDF,
                    'Creado': restaurantes[i].createdAt.split('T')[0]
                })
            }
        }

        exportFromJSON({ data: datos, fileName: "Reporte_Restaurantes", exportType: "csv" })

    }

    useLayoutEffect(() => {
        getRestaurantes()
    }, [])

    return (
        <>
            <CModal size='xl' visible={visible} onClose={() => { setVisible(false) }}>
                <CModalHeader closeButton>Nuevo restaurante</CModalHeader>
                <CModalBody>
                    <InsertRestaurante setVisible={setVisible} restaurantes={restaurantes} setRestaurantes={setRestaurantes} />
                </CModalBody>
            </CModal>

            <CModal size='xl' visible={visible2} onClose={() => { setVisible2(false) }}>
                <CModalHeader closeButton>Editar restaurante</CModalHeader>
                <CModalBody>
                    <EditRestaurante setVisible2={setVisible2} infoEdit={infoEdit} infoEditOG={infoEditOG} setInfoEdit={setInfoEdit} arrayContiene={restaurantes} setArrayContiene={setRestaurantes} arrayContieneOG={restaurantesOG} setArrayContieneOG={setRestaurantesOG} />
                </CModalBody>
            </CModal>

            <CModal visible={visible3} onClose={() => setVisible3(false)}>
                <CModalHeader closeButton>Descarga el Qr de {modalTitle}</CModalHeader>

                <CModalBody style={{ display: 'flex', justifyContent: "center", alignItems: 'center' }}>
                    <QR id={idparaQR} ref={qrRef} />
                </CModalBody>

                <CModalFooter>
                    <CButton color="success" onClick={downloadQR}>Descargar JPG</CButton>
                </CModalFooter>
            </CModal>

            <div className='centro'>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '3px', marginBottom: '10px' }}>
                    <CFormInput style={{ "width": "30%" }} type="text" id="floatingInput" label="Buscador" placeholder='Buscar' onChange={((e) => { handleChange(e.target.value) })} />

                    <h5>{restaurantes.length} restaurantes registrados</h5>
                    <div style={{ display: 'flex', gap: '30px' }}>
                        <CButton color='info' className='boton' onClick={() => setVisible(true)}> <i className="fa-solid fa-plus"></i> Agregar restaurante</CButton>
                        <CButton color="success" onClick={exportarExcel}><i className="far fa-file-excel"></i> CSV  </CButton>
                    </div>
                </div>


                {
                    !loading ?
                        restaurantes.length == 0 ?
                            <div style={{ textAlign: 'center' }}><h1>No hay restaurantes registradas</h1></div>

                            :
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                                gap: '10px',
                                width: '100%',
                            }}>
                                {
                                    restaurantes.map((item, index) => {
                                        return (
                                            <CCard key={item._id}>
                                                {/* <CCardImage style={{ width: '200px', height: '200px', objectFit: 'contain', borderRadius: '12px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', alignSelf: 'center', marginTop: '10px' }} orientation="top" src={`https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/logo/logo${item._id}.jpg?${Date.now()}`} /> */}
                                                <CCardBody>
                                                    <CCardTitle>{item.name?.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CCardTitle>
                                                    <div>
                                                        <h6>{item.type?.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</h6>
                                                        <h6>Dirección<br />{item.address?.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</h6>
                                                        <h6>Tel. {item.tel}</h6>
                                                        <h6>Email. {item.email}</h6>
                                                        <h6>Whatsapp. {item.whatsapp}</h6>
                                                        <h6>{item.drinks.length} Bebidas registradas</h6>
                                                        {
                                                            item.redes?.length > 0
                                                                ? item.redes.map((red, i) => {
                                                                    let [key, url] = Object.entries(red)[0]; // sacar el par key/valor
                                                                    return (
                                                                        <a key={i} href={url} rel="noopener noreferrer" style={{ marginRight: '0.5rem', }}>
                                                                            {
                                                                                key.charAt(0).toUpperCase() + key.slice(1) == "Instagram" ?
                                                                                    <i className="fa-brands fa-instagram"></i>
                                                                                    : key.charAt(0).toUpperCase() + key.slice(1) == "Facebook" ?
                                                                                        <i className="fa-brands fa-facebook"></i>
                                                                                        : key.charAt(0).toUpperCase() + key.slice(1) == "X" ?
                                                                                            <i className="fa-brands fa-x"></i>
                                                                                            : key.charAt(0).toUpperCase() + key.slice(1) == "Youtube" ?
                                                                                                <i className="fa-brands fa-youtube"></i>
                                                                                                : key.charAt(0).toUpperCase() + key.slice(1) == "TikTok" ?
                                                                                                    <i className="fa-brands fa-tiktok"></i>
                                                                                                    : key.charAt(0).toUpperCase() + key.slice(1)

                                                                            }
                                                                        </a>
                                                                    )
                                                                })

                                                                : 'Sin redes'
                                                        }
                                                    </div>
                                                </CCardBody>
                                                <CCardFooter>
                                                    <div
                                                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '0.6rem', }}>
                                                        <CTooltip content="Ver en Google Maps">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color='info' href={item.googleMapsURL} target="_blank" rel="noopener noreferrer"
                                                            >
                                                                <i className="fa-solid fa-map-location-dot"></i>
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="Editar">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color='success'
                                                                onClick={() => { setInfoEdit(item); setInfoEditOG(item); setVisible2(true) }}>
                                                                <i className="fa-solid fa-pen-to-square"></i>
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="qr">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color='warning' onClick={() => { setIdparaQR(item._id); setModalTitle(item.name); setVisible3(true) }}>
                                                                <i className="fa-solid fa-qrcode"></i>
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="Repetir Sucursal">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color='success'
                                                                onClick={() => { repetirSucursal(item) }}>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="Eliminar sucursal">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color='danger'
                                                                onClick={() => { eliminarSucursal(item) }}>
                                                                <i className="fa-solid fa-trash"></i>
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="Próximamente">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color={item.commingSoon ? 'danger' : 'success'}
                                                                onClick={() => { commingSoon(item) }}>
                                                                {item.commingSoon ? <i className="fa-solid fa-xmark"></i> : <i className="fa-solid fa-check"></i>}
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="Publicado">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color={item.published ? 'success' : 'danger'}
                                                                onClick={() => { published(item) }}>
                                                                {item.published ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                                                            </CButton>
                                                        </CTooltip>

                                                        <CTooltip content="Destacado">
                                                            <CButton style={{ width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, borderRadius: '10px' }} color={item.featured ? 'success' : 'danger'}
                                                                onClick={() => { featured(item) }}>
                                                                {item.featured ? <i className="fa-solid fa-star"></i> : <i className="fa-regular fa-star"></i>}
                                                            </CButton>
                                                        </CTooltip>

                                                    </div>
                                                </CCardFooter>
                                            </CCard>
                                        )
                                    })
                                }
                            </div>
                        :
                        <div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div>
                }

            </div>
        </>
    )
}

export default Restaurantes
